import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, unref as _unref, withCtx as _withCtx } from "vue"

const _hoisted_1 = { key: 1 }
const _hoisted_2 = { class: "d-flex justify-content-between" }
const _hoisted_3 = { class: "element-header" }
const _hoisted_4 = { class: "element-box" }
const _hoisted_5 = { class: "form-header mb-4" }
const _hoisted_6 = {
  key: 1,
  class: "table-responsive overflow-auto pt-4"
}
const _hoisted_7 = { class: "table table-striped" }
const _hoisted_8 = { style: {"text-align":"right","padding-right":"30px","min-width":"150px"} }
const _hoisted_9 = { class: "text-end" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = ["onClick"]

import clientService from '@/api/Client';
import Pagination from '@/components/Pagination.vue';
import router from '@/router';
// @ts-ignore
import {getClientDropdown, getOfficeDropdown} from '@/shared/dropdowns';
import {CloseToast, ErrorToast, SuccessToast} from '@/components/VueToast';
import Search from '@/views/App/Client/Search.vue';
import CreateButton from '@/components/CreateButton.vue';
import EmptyState from '@/components/EmptyState.vue';
import Loader from '@/components/Loader.vue';
import ModalDelete from '@/components/modal/ModalDelete.vue';
import PageTemplate from '@/components/PageTemplate.vue';
import PerPage from '@/components/PerPage.vue';
import {onMounted, ref} from 'vue';
import {useI18n} from 'vue-i18n';
import {downloadFile} from "@/shared/functions";
import {IClientFilters, IClientList} from "@/interfaces/Client/IClient";
import {ISelectOption} from "@/interfaces/Course/SocioTherapy/ICoursePrice";
import ExcelExportButton from "@/components/ExcelExportButton.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'List',
  setup(__props) {

const {t} = useI18n();
const filters = ref<IClientFilters>({
  clientId: '',
  officeId: '',
  sortBy: '',
  page: 1,
  limit: 10,
});

const clients = ref<IClientList>();
const clientId = ref(0);
const officeDropdown = ref<ISelectOption[]>([])
const clientDropdown = ref<ISelectOption[]>([])
const isSearching = ref(false);
const showModal = ref(false);
const isLoaded = ref(false);
const isExcelLoaded = ref(false);

async function getClients(
    page: number | undefined = 1,
    perPage?: number,
    passedFilters?: IClientFilters
) {
  CloseToast();

  if (passedFilters) {
    isSearching.value = true;
  }
  const perPageRes = clients.value?.pagination?.items_per_page;

  try {
    const {data} = await clientService.getClients({
      ...(passedFilters ? passedFilters : filters.value),
      page: page,
      limit: perPage ?? perPageRes!,
    });

    clients.value = data;
    isSearching.value = false;
  } catch (error) {
    await ErrorToast(error);
    isSearching.value = false;
  }
}

async function deleteClient() {
  try {
    await clientService.deleteClient(clientId.value);

    filters.value.clientId = '';
    filters.value.locationId = '';
    showModal.value = false;

    await getClients();
    SuccessToast(t('general.toasts.delete_success'));
  } catch (error) {
    await ErrorToast(error);
  }
}

function deleteModal(id: number) {
  CloseToast();
  clientId.value = id;
  showModal.value = true;
}

async function getExcelExport() {
  await downloadFile('/client/excel-export',
      undefined,
      filters.value,
      false,
      "GET",
      isExcelLoaded
  )
}

onMounted(async () => {
  await Promise.all([
    getClients(),
    getClientDropdown(clientDropdown),
    getOfficeDropdown(officeDropdown),
  ]);

  isLoaded.value = true;
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(PageTemplate, null, {
    default: _withCtx(() => [
      (!isLoaded.value)
        ? (_openBlock(), _createBlock(Loader, { key: 0 }))
        : (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("h6", _hoisted_3, _toDisplayString(_ctx.$t('client.title')), 1),
              _createVNode(CreateButton, {
                label: _ctx.$t('client.create'),
                to: { name: 'clientForm' }
              }, null, 8, ["label"])
            ]),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("h5", _hoisted_5, _toDisplayString(_ctx.$t('client.list')), 1),
              _createVNode(Search, {
                filters: filters.value,
                loading: isSearching.value,
                clientDropdown: clientDropdown.value,
                officeDropdown: officeDropdown.value,
                onSearch: getClients
              }, null, 8, ["filters", "loading", "clientDropdown", "officeDropdown"]),
              _createVNode(PerPage, {
                values: [10, 25, 50, 100],
                "onUpdate:perPage": getClients
              }),
              _createVNode(ExcelExportButton, {
                style: {"margin-right":"15px"},
                label: _ctx.$t('general.excel_export'),
                loading: isExcelLoaded.value,
                onClick: getExcelExport
              }, null, 8, ["label", "loading"]),
              (!clients.value?.data?.length)
                ? (_openBlock(), _createBlock(EmptyState, {
                    key: 0,
                    icon: "fa-building",
                    title: "Keine Kostenträger gefunden",
                    subtitle: "Es wurden keine Kostenträger gefunden, die Ihren Suchkriterien entsprechen."
                  }))
                : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _createElementVNode("table", _hoisted_7, [
                      _createElementVNode("thead", null, [
                        _createElementVNode("tr", null, [
                          _createElementVNode("th", null, _toDisplayString(_ctx.$t('general.client_number')), 1),
                          _createElementVNode("th", null, _toDisplayString(_ctx.$t('general.client')), 1),
                          _createElementVNode("th", null, _toDisplayString(_ctx.$t('general.address_1')), 1),
                          _createElementVNode("th", null, _toDisplayString(_ctx.$t('general.address_2')), 1),
                          _createElementVNode("th", null, _toDisplayString(_ctx.$t('general.postal_code')), 1),
                          _createElementVNode("th", null, _toDisplayString(_ctx.$t('general.city')), 1),
                          _createElementVNode("th", null, _toDisplayString(_ctx.$t('general.location')), 1),
                          _createElementVNode("th", _hoisted_8, _toDisplayString(_ctx.$t('general.actions')), 1)
                        ])
                      ]),
                      _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(clients.value?.data, (client) => {
                          return (_openBlock(), _createElementBlock("tr", {
                            key: client.id
                          }, [
                            _createElementVNode("td", null, _toDisplayString(client?.customerNumber), 1),
                            _createElementVNode("td", null, _toDisplayString(client?.name), 1),
                            _createElementVNode("td", null, _toDisplayString(client?.addressFirst), 1),
                            _createElementVNode("td", null, _toDisplayString(client?.addressSecond), 1),
                            _createElementVNode("td", null, _toDisplayString(client?.zip), 1),
                            _createElementVNode("td", null, _toDisplayString(client?.city), 1),
                            _createElementVNode("td", null, _toDisplayString(client?.registrationOffice), 1),
                            _createElementVNode("td", _hoisted_9, [
                              _createElementVNode("button", {
                                class: "btn btn-primary",
                                onClick: ($event: any) => (_unref(router).push({name: 'clientForm', params: {id: client?.id} }))
                              }, [...(_cache[1] || (_cache[1] = [
                                _createElementVNode("i", { class: "os-icon os-icon-edit" }, null, -1)
                              ]))], 8, _hoisted_10),
                              _createElementVNode("button", {
                                class: "btn btn-danger ms-2",
                                onClick: ($event: any) => (deleteModal(client?.id!))
                              }, [...(_cache[2] || (_cache[2] = [
                                _createElementVNode("i", { class: "os-icon os-icon-trash" }, null, -1)
                              ]))], 8, _hoisted_11)
                            ])
                          ]))
                        }), 128))
                      ])
                    ])
                  ])),
              (clients.value?.pagination?.total_pages ?? 0 > 1)
                ? (_openBlock(), _createBlock(Pagination, {
                    key: 2,
                    totalPages: clients.value?.pagination?.total_pages,
                    currentPage: clients.value?.pagination?.current_page,
                    totalItems: clients.value?.pagination?.total_items,
                    perPage: clients.value?.pagination?.items_per_page,
                    onPagechanged: getClients
                  }, null, 8, ["totalPages", "currentPage", "totalItems", "perPage"]))
                : _createCommentVNode("", true)
            ])
          ])),
      _createVNode(ModalDelete, {
        modelValue: showModal.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((showModal).value = $event)),
        header: _unref(t)('general.delete_item_header'),
        onDelete: deleteClient
      }, null, 8, ["modelValue", "header"])
    ]),
    _: 1
  }))
}
}

})